import styled from '@emotion/styled';

export const Container = styled.div`
  width: '100%';
  height: 420px;
  background-color: #11182b;
  border-radius: 10px;

  @media only screen and (max-width: 720px) {
    height: 360px;
    border-radius: 0px;
    margin-left: -16px;
    margin-right: -16px;
  }
`;
